export const getDentalPrescriptionDataJson = () => ({
  clinicalExamination: [],
  investigations: [],
  treatmentAdvice: [],
  medicalHistory: [],
  medicines: [],
  additionalNotes: "",
  followupDate: null,
});